import React from "react";

const Footer = () => {
  return (
    <footer className="py-5 bg-dark">
      <div className="container">
        <p className="m-0 text-center text-muted">
          ul. Duninowska 2, 87-806 Włocławek | 600 762 522 | <a href="mailto:czereba@o2.pl">czereba@o2.pl</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
